import { ThunkDispatch as Dispatch } from "redux-thunk";

import { ACTION_TYPES } from "./constants";
import { Actions } from "./types";
import { getBalanceAction } from "./balance";
import { setLoadingAction } from "./loading";

import { State } from "../types";
import { RootState } from "../store";
import { CollateralMintName as SolanaCollateralMintName } from "../config/solana.types";

import { WalletAdapterName } from "../adapters/WalletAdapter";

export const setMintCollateralMintAction = (
  collateralMintName: SolanaCollateralMintName
) => ({
  type: ACTION_TYPES.SET_MINT_COLLATERAL_MINT,
  payload: {
    collateralMintName,
  },
});

export const setMintAmountsAction = (payload: {
  collateralAmount: string;
  redeemableAmount: string;
}) => ({
  type: ACTION_TYPES.SET_MINT_AMOUNTS,
  payload,
});

export const mintAction =
  (amount: string, collateralMintName: SolanaCollateralMintName) =>
  async (
    dispatch: Dispatch<
      State,
      void,
      Actions.SetLoading | Actions.MintSuccess | Actions.CreateNotification
    >,
    getState: () => RootState
  ): Promise<string> => {
    const walletAdapterName = ((state: State) => state.wallet)(getState());

    if (!walletAdapterName) {
      throw new Error("Missing wallet in `state.wallet`.");
    }

    const uiSlippage = ((state: RootState) => state.slippage)(getState());

    let mintFunction: () => Promise<string> = () => {
      throw new Error("Unreachable");
    };
    switch (window.__UXD__.config.chain) {
      case "solana":
      default:
        const walletAdapter = window.__UXD__.solana.config.getWalletAdapter(
          walletAdapterName as WalletAdapterName
        );

        mintFunction = () =>
          window.__UXD__.solana.services.router.mint(
            Number(amount),
            walletAdapter
          );
    }

    try {
      dispatch(setLoadingAction(true));

      const txId = await mintFunction();

      dispatch({ type: ACTION_TYPES.MINT_SUCCESS });

      return txId;
    } catch (err) {
      throw err;
    } finally {
      dispatch(getBalanceAction(collateralMintName, "UXD"));
      dispatch(setLoadingAction(false));
    }
  };
